import React, { Component, Fragment } from 'react';
import Works from "../components/work/works";
import ResponsiveAppBar from '../components/components/appbar';
import ResponsiveFooter from '../components/components/footer';
class Work extends Component {
    render() {

        return (
            <Fragment>
                <ResponsiveAppBar />
                <div className="pageHeight">
                    <Works />
                </div>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default Work;